import React from 'react';
import {
  kycGotoNextPage as kycGotoNextPageRoutine,
  kycSetDraftCompanyDetails,
} from 'spa/actions/VerificationActions';
import { connect } from 'react-redux';
import { getVerifyButtonNextPage } from 'spa/utils/Verification';
import VerificationConstants, { KYCPages } from 'spa/constants/VerificationConstants';
import {
  buyerCheckoutDetailsSelector,
  customerKycDraftCompanyDetailsSelector,
} from 'spa/selectors/CustomerSelectors';
import SubmitButton from '../../StartTransaction/SubmitButton';

const COMPANY_DETAILS_FIELDS = [
  'account-type',
  'company-name',
  'company-country',
  'company-full-country',
  'company-address',
  'company-complete-address',
  'company-city',
  'company-state',
  'company-post-code',
  'industry_id',
];

const VerifyButton = ({
  verificationStatusText,
  company,
  fullWidth,
  loadNextPage,
  companyDetails,
  draftCompanyDetails,
  setDraftCompanyDetails,
}) => {
  let text = '';
  let nextPage;

  switch (verificationStatusText) {
    case 'Under Review':
    case '':
      text = 'Verify now';
      break;
    case 'Rejected':
      text = 'Resubmit Verification';
      break;
    case 'Information Missing':
      text = 'Submit Information';
      nextPage = KYCPages.HAS_UBO_FORM;
      break;
    case 'Additional Document Required':
    case 'Document Required':
      text = fullWidth ? 'Upload document' : 'Upload requested document';
      break;
    default:
      break;
  }

  const onClick = () => {
    // When attempting to T4 (via this button), we want to redirect to UBO forms if they
    // haven't been done yet. Since HasUBOForm has a safety check where it redirects back
    // to CompanyDetailsForm when draftCompanyDetails is unset, we prefill it from the
    // customer's already-saved company data so it doesn't redirect.
    if (nextPage === KYCPages.HAS_UBO_FORM && !draftCompanyDetails && companyDetails) {
      setDraftCompanyDetails({
        values: { ...companyDetails, 'account-type': VerificationConstants.ACCOUNT_TYPE_COMPANY },
        registeredFields: COMPANY_DETAILS_FIELDS,
      });
    }
    loadNextPage({ nextPage: nextPage || getVerifyButtonNextPage(company) });
  };

  if (text) {
    return (
      <SubmitButton
        fullWidth={fullWidth}
        onClick={onClick}
        muiVariant="contained"
        data-testid="kyc-details-verify-button"
      >
        {text}
      </SubmitButton>
    );
  }

  return null;
};

const mapStateToProps = (state) => ({
  companyDetails: buyerCheckoutDetailsSelector(state),
  draftCompanyDetails: customerKycDraftCompanyDetailsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadNextPage: (nextPage) => dispatch(kycGotoNextPageRoutine.trigger(nextPage)),
  setDraftCompanyDetails: (payload) => dispatch(kycSetDraftCompanyDetails(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyButton);
